import parse, { HTMLReactParserOptions } from 'html-react-parser';
import { camelCase, upperFirst } from 'lodash';

export const isString = (value: unknown) => typeof value === 'string';

export const parseString = (string: string, options?: HTMLReactParserOptions) =>
  string ? parse(string, options) : '';

export const parseUnicode = (string: string | undefined) => {
  if (!string) {
    return '';
  }

  return string.replace(/\\u([0-9a-fA-F]{4})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
};

export const formatString = (string: string, wordToReplace: string) => {
  return string
    .toLowerCase()
    .replace(wordToReplace, '')
    .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
};

export const hasContent = (htmlContent: string) => {
  // Remove HTML tags in order to check if empty
  const plainText = stripHtmlTags(htmlContent);

  return !!plainText;
};

export const isUpperCase = (string: string) => string === string.toUpperCase();

export const stripHtmlTags = (html?: string): string => html && html.replace(/<\/?[^>]+(>|$)/g, '');

// Uses DOMParser so HTML entities (&nbsp;, &amp;, ...) are decoded to the single
// character the user sees, rather than counted as their raw entity string.
export const getPlainTextLength = (html?: string): number => {
  if (!html) {
    return 0;
  }

  return (new DOMParser().parseFromString(html, 'text/html').body.textContent ?? '').length;
};

export const containsHtmlTags = (html: string) => /<[^>]+>/.test(html);

export const removeBrFromStartOrEnd = (htmlString: string) => {
  const startBrRegex = /^(<p><br><\/p>|<br\s*\/?>)+/i;
  const endBrRegex = /(<p><br><\/p>|<br\s*\/?>)+$/i;

  return htmlString.replace(startBrRegex, '').replace(endBrRegex, '');
};

export const pascalCase = (string: string) => upperFirst(camelCase(string));

export const snakeToCamelLabel = (snakeCase: string): string => `label${pascalCase(snakeCase)}`;
